var normalizeComponent = require("!../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./options-worlab.vue"
/* template */
import __vue_template__ from "!!../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d41e3b80\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./options-worlab.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/sd2000/import/components/exames-nao-importados/components/item-importation/components/options-worlab.vue
// module id = null
// module chunks = 